import React, { Component} from 'react'
import {Link} from 'react-router-dom'



const TabContentDriver = (props)=>{
     var isShow = props.currentIndex === 0 ? 'active' : '';
    return(
        <div className='tab-item'  data-show = {isShow} style = {props.driverBgImg}>        
            <div className='max-width-box'>
                <div className='driver-content'>
                    <h3>整体解决方案</h3>
                    <p>移动接单和报柜号、货运交易、账单管理、在线报账</p>
                    <div className='view-detail'>
                        <Link to='/productService'>查看详情</Link>  
                    </div>
                </div>  
            </div>    
        </div>
       
    )
}


const TabContentFreight = (props)=>{
    var isShow = props.currentIndex === 1 ? 'active' : '';
    return(
        <div className='tab-item'  data-show = {isShow} style = {props.driverBgImg}>        
            <div className='max-width-box'>
                <div className='driver-content'>
                    <h3>整体解决方案</h3>
                    <p>业务单全流程管理、上下游企业协同办公、货物全程可视化、商务财务管理、公共信息查询（港口、装卸地址、船期表、港杂费） 、经营决策分析、员工评级</p>
                    <div className='view-detail'>
                        <Link to='/productService'>查看详情</Link>  
                    </div>
                </div>  
            </div>    
        </div> 
    )
}


const TabContentCar = (props)=>{
    var isShow = props.currentIndex === 2 ? 'active' : '';
    return(
        <div className='tab-item'  data-show = {isShow} style = {props.driverBgImg}>        
            <div className='max-width-box'>
                <div className='driver-content'>
                    <h3>整体解决方案</h3>
                    <p>业务单全流程管理、上下游企业协同办公、移动派车、车辆动态跟踪、商务财务管理、经营决策分析、员工评级</p>
                    <div className='view-detail'>
                        <Link to='/productService'>查看详情</Link>  
                    </div>
                </div>  
            </div>    
        </div> 
    )
}



const TabContentGoodsOwner = (props)=>{
    var isShow = props.currentIndex === 3 ? 'active' : '';
    return(
        <div className='tab-item' data-show = {isShow} style = {props.driverBgImg}>        
            <div className='max-width-box'>
                <div className='driver-content'>
                    <h3>整体解决方案</h3>
                    <p>货物轨迹查看、异常提醒、船期价格查询</p>
                    <div className='view-detail'>
                        <Link to='/productService'>查看详情</Link>  
                    </div>
                </div>  
            </div>    
        </div>  
    )
}



export class Tabs extends Component {
    constructor(props) {
    	super(props);
    	this.state = {
    		tab: {
    			current_index: 0,
    		},
    	};
    }
    
    tabClick = (num,e) => {
        e.stopPropagation();
		this.setState({
			tab: Object.assign(
				this.state.tab, {
					current_index: num,
				},
			),
		});
    }


    
    render(){
        const state = this.state;
        const currentIndex = state.tab.current_index;

        return (<div className='tabs'>
                    <div className='tab-content'>
                       
                        <TabContentDriver driverBgImg = {this.props.driverBgImg4} currentIndex = {currentIndex}  />
                        <TabContentFreight driverBgImg = {this.props.driverBgImg2} currentIndex = {currentIndex}  />
                        <TabContentCar driverBgImg = {this.props.driverBgImg1} currentIndex = {currentIndex}  />
                        <TabContentGoodsOwner driverBgImg = {this.props.driverBgImg3} currentIndex = {currentIndex}  />
                    </div>
                    <div className='tab-nav'>
                        <div className='max-width-box'>
                            <a href="javascript:void(0)" onClick={(e) => this.tabClick(0,e)} 
                            className={currentIndex === 0 ? 'active' : ''} >
                                <i className='triangle_border_up' data-show = {currentIndex === 0 ? 'show' : ''}></i>
                                我是司机
                            </a>
                            <a href="javascript:void(0)" onClick={(e) => this.tabClick(1,e)}
                            className={currentIndex === 1 ? 'active' : ''} >
                                <i className='triangle_border_up' data-show = {currentIndex === 1 ? 'show' : ''}></i>
                                我是货代
                            </a>
                            <a href="javascript:void(0)" onClick={(e) => this.tabClick(2,e)}
                            className={currentIndex === 2 ? 'active' : ''}>
                                <i className='triangle_border_up' data-show = {currentIndex === 2 ? 'show' : ''}></i>
                                我是车队
                            </a>
                            <a href="javascript:void(0)" onClick={(e) => this.tabClick(3,e)}
                            className={currentIndex === 3 ? 'active' : ''}>
                                <i className='triangle_border_up' data-show = {currentIndex === 3 ? 'show' : ''}></i>
                                我是货主
                            </a>
                        </div>
                        
                    </div>
                </div>
        )
    }
  
}






// WEBPACK FOOTER //
// ./src/components/tabs/index.js